import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    axios
      .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((res) => {
        const dest = res.data?.role === "admin" ? "/portal/admin" : "/portal";
        window.history.replaceState(null, "", dest);
        navigate(dest, { state: { user: res.data }, replace: true });
      })
      .catch(() => navigate("/login", { replace: true }));
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-[#060D1A] flex items-center justify-center" data-testid="auth-callback-loading">
      <p className="font-mono-label text-xs uppercase tracking-[0.3em] text-slate-400">
        Signing you in…
      </p>
    </div>
  );
}
